import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomerSearchResult } from 'src/app/core/models/customer-search-result';
import { CustomerService } from 'src/app/core/services/customer.service';
import { TranslateService } from '@ngx-translate/core';
import { Utils } from 'src/app/core/utils';

@Component({
  selector: 'app-enter-id-dialog',
  templateUrl: './enter-id-dialog.component.html',
  styleUrls: ['./enter-id-dialog.component.scss']
})
export class EnterIdDialogComponent implements OnInit {

  
  error:string = '';


  constructor(
    private translate: TranslateService,
    private customerService: CustomerService,
    public dialogRef: MatDialogRef<EnterIdDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EnterIdNumberData
  ) { }

  ngOnInit() {
  }

  onCancel(){
    this.data.action = 'canceled';
    this.dialogRef.close();
  }

  onOK() {
    
    const customerID = this.data.customerID;
    const idNumber:string = this.data.idNumber;
    const idType:number = this.data.idType;

    this.customerService.updateIDNumber(customerID, idNumber, idType).subscribe(result =>{
      
      if(result.Code === 1){
        this.data.action = 'confirmed';
        this.dialogRef.close(this.data);
      
      } else {
        this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
      }
    },
    error => this.error = error);

    
  }

  isValid(){
    
    var isValid = false;
    var id = this.data.idNumber && this.data.idNumber.trim() || '';

    // empty is invalid
    if(id === ''){
      return false;
      
    } else if(this.data.idType == 1){ // TZ
      isValid = Utils.IsValidIsraeliID(this.data.idNumber);

    } else if(this.data.idType == 2){ // Passport
      isValid = this.data.idNumber.length > 0;
    }
    return isValid;
  }
}


export interface EnterIdNumberData {  
  customerID: number;
  idType: number; // 1-TZ, 2-Passport
  idNumber: string;
  action: string;
}

